import { GET_ENTITY_CHOICES } from './EntityType';

const initialState = {
    entityChoices: null
};
export const entityReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ENTITY_CHOICES.SUCCESS:
            return { ...state, entityChoices: action.payload };
        default:
            return state;
    }
};
